import {
    clearSearchBox,
    lazySetIsSuggestionsDropdownVisible,
    suggestionSelected,
} from 'owa-search';
import { orchestrator } from 'satcheljs';

import isFileSuggestionsSearchAction from '../utils/isFileSuggestionsSearchAction';

export default orchestrator(suggestionSelected, async actionMessage => {
    const { scenarioId } = actionMessage;
    if (!isFileSuggestionsSearchAction(scenarioId)) {
        return;
    }
    // Make sure to clear the searchBox
    clearSearchBox(scenarioId);

    // Hide suggestions dropdown.
    const setIsSuggestionsDropdownVisible = await lazySetIsSuggestionsDropdownVisible.import()!;
    setIsSuggestionsDropdownVisible(false /* isSuggestionsDropdownVisible */, scenarioId);
});
